import CybsButton from '@cybs-ui/components/lib/button';
import React from 'react';
import { connect } from 'react-redux';
import { putDataInDevCenterDataStore } from '../../../../../app/store';
import { showDivBasedOnId } from '../../../../../commons/ui-commons';
import {computeHeightOfHeaderForRhs}from './../../../../../commons/header-footer';



class ExpandedDescriptions extends React.Component
{

   render()
   {
       return(
        <CybsButton
        aria-label="Expand button for the request details"
        aria-description="On click of this button the request details will be shown"
        colorScheme="primary"
        dataTest="expandButton"
        i18n={{label: 'Expand' }}
        iconClass="maximize"
        iconLocation="left"
        disabled={this.props.isRequestDescriptionExpanded}
        onClick={() => {showDivBasedOnId('expanded-request-field-descriptions'); putDataInDevCenterDataStore({type:'UPDATE_IS_REQUEST_DESCRIPTION_EXPANDED', isRequestDescriptionExpanded: true}); computeHeightOfHeaderForRhs();}}
    />
       );

    }
}
function mapStateToProps(state){
    return{      
        sampleCodeError: state.examplesReducer.sampleCodeError,
        sampleCodeUrl: state.examplesReducer.sampleCodeUrl,
        isRequestDescriptionExpanded: state.rhsReducer.isRequestDescriptionExpanded
    };
   
} 

export default connect(mapStateToProps)(ExpandedDescriptions);